module.exports = __webpack_public_path__ + "static/media/logo_brasil_cae.4bc9dd8f.png";